module.exports = __webpack_public_path__ + "img/icon_map_ss_c.462ba7df.png";